import React from 'react'
import { connect, useDispatch } from 'react-redux'

import {
  HouseAndLandInterface,
  setByFlag,
} from '@store/actionSlices/houseAndLand'
import { RootStateType } from '@store/store'

import DropDown from '@components/dropdown'

import { HouseAndLandActiveKeyType } from '@api/types/house-and-land-type'

interface Props {
  houseAndLand: HouseAndLandInterface
}
function PrecinctDropdown({ houseAndLand }: Props) {
  const dispatch = useDispatch()
  const precincts = houseAndLand.precinctList
  const packageSummary = houseAndLand.matrixData[houseAndLand.activePrecinctId]

  const currentPrecinct = React.useRef('')
  const precinctLength = React.useMemo(() => precincts.length, [precincts])

  const precinctOptions = React.useMemo(
    () =>
      houseAndLand.precinctList.map(({ label }) => ({
        label,
        value: label,
      })),
    [houseAndLand.precinctList]
  )

  const onChangeBlock = React.useCallback(
    (value: string) => {
      dispatch(
        setByFlag({
          flag: HouseAndLandActiveKeyType.ActivePrecinctId,
          value,
        })
      )
      dispatch(
        setByFlag({
          flag: HouseAndLandActiveKeyType.ActiveLotId,
          value: '',
        })
      )
      currentPrecinct.current = value
    },
    [dispatch]
  )

  React.useEffect(() => {
    if (currentPrecinct.current !== houseAndLand.activePrecinctId) return

    const firstStageId = Object.keys(packageSummary?.stages ?? {})[0]
    dispatch(
      setByFlag({
        flag: HouseAndLandActiveKeyType.ActiveStageId,
        value: firstStageId,
      })
    )
  }, [packageSummary, houseAndLand.activePrecinctId])

  if (precinctLength <= 1) return null

  return (
    <DropDown
      onSelect={onChangeBlock}
      items={precinctOptions}
      value={houseAndLand.activePrecinctId || precinctOptions[0].value}
      className="py-2"
      buttonRadius="rounded-[7px]"
      buttonRadiusClasses="rounded-tl-[7px] rounded-tr-[7px]"
      optionRadiusClasses="rounded-bl-[7px] rounded-br-[7px]"
    />
  )
}

export default connect(({ houseAndLand }: RootStateType) => ({
  houseAndLand,
}))(PrecinctDropdown)
